import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { ID } from '@sdk/newsfeed/types/apiTypes';
import useSlingApi from '@sdk/api/useSlingApi';
import useToast from '@sdk/common/toast/useToast';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';

import { useNewsfeedMappers } from '@web/newsfeed/hooks/useNewsfeedMappers';
import { getArticleQueryKey } from '@web/newsfeed/utils/getQueryKey';
import {
  NEWSFEED_ARTICLE_CACHE_TIME,
  NEWSFEED_ARTICLE_STALE_TIME,
} from '@web/newsfeed/consts/cache';

export const useGetArticle = (pageId: ID, articleId: ID) => {
  const { newsfeed } = useSlingApi();
  const queryKey = getArticleQueryKey(articleId);
  const { showErrorToast } = useToast();
  const { isReady, mapAPIArticleToUI } = useNewsfeedMappers();

  const result = useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await newsfeed.getArticle({ pageId, articleId });
      return mapAPIArticleToUI(data);
    },
    cacheTime: NEWSFEED_ARTICLE_CACHE_TIME,
    enabled: isReady,
    staleTime: NEWSFEED_ARTICLE_STALE_TIME,
  });

  useEffect(() => {
    if (result.error) {
      showErrorToast(getErrorForToast(result.error));
    }
  }, [result.error, showErrorToast]);

  return result;
};
